export default "__VITE_ASSET__B$Vyli6V__"